import React, { useEffect, useState } from "react";
import style from './variantEditModalTabel.module.scss'

const WarningError = (props) => {

    const [errorData, setErrorData] = useState({
        isOpen: props.index == '0' ? true : false,
        loadingButton: false,
        calcSuccess: false,
    })

    const handleClick = async () => {
        let tmp = errorData
        tmp.loadingButton = true
        setErrorData({ ...tmp })
        let res = await props.buttonAction()
        tmp.loadingButton = false
        tmp.calcSuccess = true
        setErrorData({ ...tmp })
    }

    return <div className={style.ErrorBoxWrapper} onClick={() => setErrorData({ ...errorData, isOpen: !errorData.isOpen })}>
        <div className={style.header}>
            <div className={style.icon}>i</div>
            <p className={style.title}>{props.title}</p>
        </div>
        {errorData.isOpen ?
            <div className={style.errorTextsFrame}>
                {props.texts.map((text, textIndex) => <p index={`textIndex_${textIndex}`} className={style.errorText}>{text}</p>)}
                {(props.buttonAction && !errorData.calcSuccess) ? <div className={style.errorActionWrapper}>
                    {errorData.loadingButton
                        ?
                        <button>
                            <div className={style.loading}>
                                <span className={style.first}></span>
                                <span className={style.secound}></span>
                                <span className={style.third}></span>
                            </div>
                        </button>
                        :
                        <button onClick={handleClick}>محاسبه بیشترین قیمت</button>
                    }
                </div>
                    :
                    errorData.calcSuccess ? <>
                        <p className={style.calcSuccess}>بیشترین قیمت با موفقیت به‌روزرسانی شد! لطفا دکمه محاسبه قیمت را دوباره کلیک کنید.</p>
                    </> : null
                }
            </div>
            :
            null
        }
    </div>
}
export default WarningError;
